import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=87415322&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=ts"
export * from "./Subscription.vue?vue&type=script&lang=ts"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=87415322&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87415322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87415322')) {
      api.createRecord('87415322', component.options)
    } else {
      api.reload('87415322', component.options)
    }
    module.hot.accept("./Subscription.vue?vue&type=template&id=87415322&scoped=true", function () {
      api.rerender('87415322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/Subscription.vue"
export default component.exports